module.exports = __webpack_public_path__ + "static/media/22.b1eaa052.png";